import React from "react";
import { Line } from "react-chartjs-2";
import "chartjs-plugin-zoom";
import download_icon from "../image/download-icon.png";
import authHeader from "../services/auth-header";
import axios from "axios";
import fileDownload from "js-file-download";

// /*eslint-disable*/
var data = [];

/*************************FUNCTIONS************************/

const Chart = ({ data1, messsage, download }) => {
  if (messsage === "successful") {
    data = data1;
  } else {
    data = [];
  }
  // console.log('chart.js',data1, data, messsage);

  /*************************DOWNLOAD DATA************************/

  var handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
        headers: authHeader(),
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  /*************************MAIN CODE************************/

  return (
    <div>
      <div className="chart-top">
        <button
          type="button"
          className="chart-download-button"
          onClick={() => {
            handleDownload(download, "Chart_data.csv");
          }}
        >
          Download
          <img
            src={download_icon}
            alt="download"
            width="15px"
            style={{ marginLeft: "10px" }}
          />
        </button>
      </div>
      <Line
        data={data}
        options={{
          responsive: true,
          // height: "100%",
          width: "100%",
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                // drag: true,
                mode: "xy",
              },
              zoom: {
                enabled: true,
                // drag: true,
                mode: "xy",
              },
            },
          },
        }}
      />
    </div>
  );
};

export default Chart;